import { type UseQueryResult, useQuery } from 'react-query';
import {
  SwitchConfigurationDto,
  SwitchConfigurationService,
} from '../../services/wealthlane-customer-services';

const useGetSwitchConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  userId: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  SwitchConfigurationDto | undefined,
  unknown
> => {
  const getCustomerSwitchConfiguration = useQuery(
    ['getCustomerSwitchConfiguration', userId],
    async () => {
      if (userId) {
        return await handleRequest(
          SwitchConfigurationService.getApiCustomerApiUserSwitchConfiguration(userId)
        );
      }
    }
  );

  return getCustomerSwitchConfiguration;
};

export default useGetSwitchConfiguration;
